import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IAfterSchoolActivity } from '../models/afterschoolActivity';

@Injectable({
    providedIn: 'root'
})
export class AfterschoolActivityService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getBuildingAfterschoolActivity(buildingId: string): Observable<{has_error: boolean, message: string; data: IAfterSchoolActivity[]}> {
        const url = environment.apiBaseUrl + endpoints.getBuildingAfterschoolActivities.replace(':buildingId', buildingId);

        return this.http.get<{has_error: boolean, message: string; data: IAfterSchoolActivity[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createAfterschoolActivity(buildingId: string, data: IAfterSchoolActivity): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createNewAfterschoolActivity.replace(':buildingId', buildingId);

        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    updateAfterschoolActivity(buildingId: string, activityId: string, data: IAfterSchoolActivity): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateAfterschoolActivity
            .replace(':buildingId', buildingId)
            .replace(':activityId', activityId);

        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    approveBuildingAfterschoolActivity(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.approveBuildingAfterschoolActivities.replace(':buildingId', buildingId);

        return this.http.post<{has_error: boolean, message: string, data: any}>(url, {}).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteAfterschoolActivity(buildingId: string, activityId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteAfterschoolActivity
            .replace(':buildingId', buildingId)
            .replace(':activityId', activityId);

        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}